import React, { useState, useEffect, useMemo, useRef } from "react";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Admin from "@system/config/admin";
import { AgGridReact } from 'ag-grid-react';
import { useUserStore } from 'src/hooks/admin/user';
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import useReduxState from 'src/hooks/useReduxState';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

export function UserList() {
    const [__check] = useAxiosIndicatorCheck();
    const [{ userList, totalRecords }, { get_user_list, get_export_user_list, email_user_list }, { set_user_list }] = useUserStore();
    const [{ filter_list }, { }, { }] = useObjCommonFilterStore();
    const [rowData, setRowData] = useState([]);
    const gridRef = useRef();
    // const gridStyle = useMemo(() => ({ height: 700 }), []);
    const [selectedUserCount, setSelectedUserCount] = useState(0);
    const [refreshGrid, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);

    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const [agGridFiltered, setAgGridFiltered] = useState(0);
    const { downloadMsg } = Constants


    const loadUserId = (e) => {
        return <>
            <a
                href={Admin.getUserDetailURL() + '?uid=' + (e?.data?.UserID ? e?.data?.UserID : e.node.allLeafChildren[0].data.UserID) + '&userType=' + e?.data?.UserType}
                className='' target="_blank" rel="noreferrer"> {e.value}</a>
        </>
    }

    const [columnDefs, setColumnDefs] = useState([
        {
            field: '', pinned: 'left', filter: 'agTextColumnFilter',
            lockPosition: "left",
            headerCheckboxSelection: true,
            checkboxSelection: true,
            showDisabledCheckboxes: true,
            width: 50,
            unSortIcon: true,
        },
        {
            field: 'Email', pinned: 'left',
            headerName: 'EMAIL',
            lockPosition: "left",
            cellRenderer: loadUserId,
            headerTooltip: 'EMAIL',
            sortable: true, comparator: Helper.textSortingAgGrid,
            unSortIcon: true,
        },
        {
            field: 'FirstName',
            pinned: 'left',
            lockPosition: "left",
            headerName: 'FIRST NAME',
            headerTooltip: 'FIRST NAME',
            sortable: true,
            comparator: Helper.textSortingAgGrid,
            unSortIcon: true,
        },
        {
            field: 'LastName',
            pinned: 'left',
            lockPosition: "left",
            headerName: 'LAST NAME',
            headerTooltip: 'LAST NAME',
            sortable: true,
            comparator: Helper.textSortingAgGrid,
            unSortIcon: true,
        },
        {
            field: 'TelephoneNumber',
            minWidth: 150,
            headerName: 'TELEPHONE NUMBER',
            headerTooltip: 'TELEPHONE NUMBER',
            sortable: true,
            comparator: Helper.textSortingAgGrid,
            unSortIcon: true,
        },
        {
            field: 'MobileNumber',
            minWidth: 150,
            headerName: 'MOBILE NUMBER',
            headerTooltip: 'MOBILE NUMBER',
            sortable: true,
            comparator: Helper.textSortingAgGrid,
            unSortIcon: true,
        },
        {
            field: 'CreatedOn',
            minWidth: 130,
            headerName: 'CREATED ON',
            headerTooltip: 'CREATED ON',
            sortable: true,
            comparator: Helper.dateSortingAgGrid,
            filter: 'agDateColumnFilter',
            filterParams: {
                suppressAndOrCondition: true,
                comparator: Helper.calendarAgGridComparator,
            },
            unSortIcon: true,
        },
        {
            field: 'Source',
            minWidth: 130,
            headerName: 'SOURCE',
            headerTooltip: 'SOURCE',
            sortable: true,
            comparator: Helper.textSortingAgGrid,
            unSortIcon: true,
        },
        {
            field: 'Active',
            minWidth: 130,
            headerName: 'STATUS',
            headerTooltip: 'STATUS',
            sortable: true,
            comparator: Helper.textSortingAgGrid,
            unSortIcon: true,
        }

    ]);

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            sortable: true,
            filter: true,
            enableRowGroup: true,
            enableValue: true,
            // lockPinned: true,
            resizable: true
            // suppressMovable: true,
            // menuTabs: ['filterMenuTab', 'columnsMenuTab'],
            // maxWidth: 250
        };
    }, []);


    useEffect(() => {
        async function fetchHere() {
            await fetchAPICall()
        }

        fetchHere();
    }, [filter_list]);

    useEffect(() => {
        async function fetchHere() {
            setSelectedUserCount(0);
            await fetchAPICall()
            setRefreshGrid(false);
        }

        if (refreshGrid)
            fetchHere();
    }, [refreshGrid]);


    useEffect(() => {
        const _userList = [];
        if (userList?.length > 0) {
            userList.map((_user, idx) => {
                const _data = {
                    UserID: _user.id,
                    Email: _user.emailAddress,
                    FirstName: _user.firstName,
                    LastName: _user.lastName,
                    TelephoneNumber: _user.telephoneNumber,
                    MobileNumber: _user.mobileNumber,
                    CreatedOn: _user.createDate ? Helper.getDatepickerFormatAdminConsole(_user.createDate) : "",
                    Source: _user.source,
                    Active: _user?.active ? 'Active' : 'Inactive',
                    UserType: _user.userType
                }
                _userList.push(_data);
            })
        }
        setRowData(_userList)
    }, [userList]);

    const fetchAPICall = async () => {
        __set('USER_API_CALL')
        if (Object.entries(filter_list).length > 0) {
            const params = {
                sortBy: "First_name",
                sortOrder: "ASC",
                firstName: filter_list?.firstName?.searchKeyword || '',
                lastName: filter_list?.lastName?.searchKeyword || '',
                emailAddress: filter_list?.email?.searchKeyword || '',
            }
            const data = await get_user_list(params)
            if (data?.payload?.Message) {
                system_alert_indicator({
                    name: "accessDenied",
                    message: data?.payload?.Message,
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false
                });
            }
        } else {
            set_user_list()
        }
        __remove('USER_API_CALL')
    };

    const onRemoveUser = () => {
        if (gridRef.current.api.getSelectedRows().length > 0) {
            System.popup('RemoveUser', { 'data': gridRef.current.api.getSelectedRows() })
        }
    };

    const openAddUser = () => {
        System.popup('AddUser')
    };
    const exportGrid = async () => {
        __set('COMMON_API_CALL');
        $('#emailFilter').removeClass('open');
        if (agGridFiltered < 2000) {
            const allColumnState = gridColumnApi.getColumnState();
            const customColumns = allColumnState
                .filter((column) => !column.hide && column.colId != '0')
                .map((column) => column.colId);
            const params = { fileName: `user_list.xlsx`, sheetName: "user", columnKeys: customColumns };
            gridRef.current.api.exportDataAsExcel(params);

            system_alert_indicator({
                name: "adminconsole",
                message: downloadMsg,
                type: "success",
                isDisplay: true,
            });
        } else {
            const params = {
                sortBy: "First_name",
                sortOrder: "ASC",
                firstName: filter_list?.firstName?.searchKeyword || '',
                lastName: filter_list?.lastName?.searchKeyword || '',
                emailAddress: filter_list?.email?.searchKeyword || '',
            }
            const data = await email_user_list(params);
            if (data?.payload?.Message) {
                system_alert_indicator({
                    name: "accessDenied",
                    message: data?.payload?.Message,
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false
                });
            } else {
            system_alert_indicator({
                name: "adminconsole",
                message: "File will be sent as an email attachment due to large number of records",
                type: "success",
                isDisplay: true,
            });
        }
        }
        __remove('COMMON_API_CALL');
    }
    const onExportAll = async () => {
        $('#emailFilter').removeClass('open');
        __set('COMMON_API_CALL');
        if (totalRecords > 0 && totalRecords < 2000) {
            const data = await get_export_user_list();
            if (data?.payload?.Message) {
                system_alert_indicator({
                    name: "accessDenied",
                    message: data?.payload?.Message,
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false
                });
            } else { 
            system_alert_indicator({
                name: "adminconsole",
                message: downloadMsg,
                type: "success",
                isDisplay: true,
            });
        }
        } else {
            const params = {
                sortBy: "First_name",
                sortOrder: "ASC",
                firstName: '',
                lastName: '',
                emailAddress: '',
            }
            const data = await email_user_list(params);
            if (data?.Message) {
                system_alert_indicator({
                    name: "accessDenied",
                    message: data?.Message,
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false
                });
                __remove('COMMON_API_CALL');
                return;
            } else {
            system_alert_indicator({
                name: "adminconsole",
                message: "File will be sent as an email attachment due to large number of records",
                type: "success",
                isDisplay: true,
            });
        }
        }
        __remove('COMMON_API_CALL');
    }

    const onSelectionChanged = () => {
        setSelectedUserCount(gridRef?.current?.api?.getSelectedRows().length);
    }

    const isRowSelectable = useMemo(() => {
        return (params) => {
            return params.data && (params.data.Source !== 'SAP' && params.data.Active !== 'Inactive' && System.validateDomain(params.data.Email) === false);
        };
    }, []);

    const gridUpdateCallback = (event) => {
        setAgGridFiltered(event.api.getDisplayedRowCount());
    }
    const onColumnResided = (event) => {
        event.columnApi.getColumn('0').setActualWidth(50);
    }

    const onGridReady = (params) => {
        setAgGridFiltered(params.api.getDisplayedRowCount());
        params.api.addEventListener('filterChanged', gridUpdateCallback)
        params.api.addEventListener('filterModified', gridUpdateCallback)
        params.api.addEventListener('columnResized', onColumnResided);
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    return (
        <>
            {rowData.length > 0 && <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
                <div className="d-flex justify-content-start">
                    Filtered Line Count: <b>{agGridFiltered}</b>
                </div>
                <div className="d-flex justify-content-end">
                    Total Records: <b>{totalRecords}</b>
                </div>
            </div>}
            <div className='bg-black p-2'>
                <div className='d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center' >
                        <button className={`bs5 btn btn-secondary ${selectedUserCount > 0 ? '' : ' disabled'}`} onClick={() => onRemoveUser()}><i className="fas5 fa-user-minus text-darkgreen me-2" aria-hidden="true"></i>Remove user</button>
                    </div>
                    <div className='d-flex align-items-center'>
                        <button className="bs5 btn btn-secondary me-3" onClick={() => openAddUser()}>
                            <i className="fas5 fa-user-plus text-darkgreen me-2" aria-hidden="true"></i>Add user</button>
                        <span id="emailFilter" className="dropdown me-2">
                            <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className='text-white'>
                                <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
                            </a>
                            <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton1">
                                <li><a href={void (0)} onClick={onExportAll}>Export All</a></li>
                                {rowData.length > 0 && <li><a href={void (0)} onClick={exportGrid}>Export Filtered</a></li>}
                            </ul>
                        </span>
                    </div>
                </div>
            </div>

            {__check(['USER_API_CALL', 'COMMON_API_CALL']).render}
            {!__check(['USER_API_CALL', 'COMMON_API_CALL']).status &&
                <>
                    {rowData?.length > 0 ?
                        <div className="ag-theme-alpine ag-grd-hg mb-5">
                            <AgGridReact
                                ref={gridRef}
                                rowData={rowData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                rowSelection={'multiple'}
                                suppressRowClickSelection={true}
                                onGridReady={onGridReady}
                                onSelectionChanged={onSelectionChanged}
                                isRowSelectable={isRowSelectable}
                                autoGroupColumnDef={{
                                    headerName: 'Group',
                                    minWidth: 220,
                                }}
                            >
                            </AgGridReact>
                        </div> :
                        <>
                            {(Object.entries(filter_list).length > 0 && rowData.length == 0) ?
                                <div className='container mt-5'>
                                    <NoResultContent message={`Sorry! We can't find any results based on your selection.`} isDisplay={false} />
                                </div>
                                : <div className='d-block pt-5 pb-5 mt-5 mb-5 minh150'> </div>
                            }
                        </>

                    }
                </>
            }
        </>

    );

}
